// extracted by mini-css-extract-plugin
export default {"arrow":"AccordionComponent_arrow__bdw+n"};